<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :fill="svgFill" 
        viewBox="0 0 16 16" 
        class="size-4">
        <path fill-rule="evenodd" d="M3.5 9.75A2.75 2.75 0 0 1 6.25 7h5.19L9.22 9.22a.75.75 0 1 0 1.06 1.06l3.5-3.5a.75.75 0 0 0 0-1.06l-3.5-3.5a.75.75 0 1 0-1.06 1.06l2.22 2.22H6.25a4.25 4.25 0 0 0 0 8.5h1a.75.75 0 0 0 0-1.5h-1A2.75 2.75 0 0 1 3.5 9.75Z" clip-rule="evenodd" />
    </svg>
</template>
    
<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps(['fill'])

const svgFill = computed(() => {
    return props.fill ? props.fill : 'black'
})
</script>